/* eslint-disable react-hooks/exhaustive-deps */
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import { Timestamp } from "firebase/firestore";
import {
  Grid,
  Typography,
  TextField,
  IconButton,
  Collapse,
  Divider,
  Button,
} from "@material-ui/core";
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import React, { useState, useEffect, useContext } from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import moment from "moment/moment";
import SingleSelect from "../../../components/SelectField/SingleSelect";
import useClientSummary from "./useClientSummary";
import styles from "../dashboard.module.scss";
import { timeSheetDeleteTime, timeSheetUpdate, timeSheetUpdateTime } from "../../../services/apiservices/timesheets";
import CircularProgress from "@mui/material/CircularProgress";
import AuthContext from "../../../hooks/authContext";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import CustomPagination from "../../../components/Pagination/Pagination";
import { addPreferenceUser } from "../../../services/apiservices/client";
import { Dialog, DialogContent, DialogTitle } from "../../../components/ui/dialog";
import { AppointmentModal } from '../../Scheduler/Models/AppointmentModel';
import { CommonConfirmationDialog, CommonSuccessDialog, DeleteApptDialog } from '../../../components/DialogComponent/SupplyDataDialog';
import { DeleteAppointment } from '../../../services/apiservices/appoinments';
import { useToast } from '../../../hooks/useToast';
import { ClockInOut } from './ClockInOutComponent';

const ShiftStatus = (props) => {
  const [selectedShift, setSelectedShift] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const getShiftData = (shiftData, shift) => {
    const result = [];
    for (let shiftObj in shiftData) {
      for (let element in shiftData[shiftObj]) {
        const title = shiftData[shiftObj][element]["title"];
        if (title !== "Opentasks") {
          result.push({
            value: title,
            label: title,
            data: shiftData[shiftObj],
            shiftId: shiftObj,
          });
        }
      }
    }
    if (result?.length === 0 || shift === "No Shift") {
    result?.push({
      value: "No Shift",
      label: "No Shift",
    });
  }
    return result;
  };

 const shiftDetails = getShiftData(
  props.appointment?.clientDetails?.shiftData,
  props?.appointment?.shift
    )?.filter(
      (obj, index, self) =>
        index === self?.findIndex((el) => el?.value === obj?.value)
    );



  const onSelectShift = async (event) => {
    const {
      target: { value },
    } = event;

    const selShiftData = shiftDetails?.find((ele) => ele.value === value);

    const apptData = {
      ...props.appointment,
      shiftId: selShiftData.shiftId,
      tasks: selShiftData.data,
    };
    delete apptData.clientDetails;
    delete apptData.id;

    setIsLoading(true);
    timeSheetUpdate(
      props.appointment.id,
      apptData,
      (result) => {
        props?.setShow(false);
        setIsLoading(false);
        props.refreshData();
      },
      (errr) => {
        props?.setShow(false);
        setIsLoading(false);
        props.refreshData();
      }
    );

    setSelectedShift(value);
  };

  useEffect(() => {
    setSelectedShift(() => {
      if (
        props.appointment?.tasks &&
        Object.keys(props.appointment?.tasks).length > 0
      ) {
        for (let ele in props.appointment?.tasks) {
          return props.appointment?.tasks[ele]["title"];
        }
      } else {
        return (
          <div>{"----"} <span style={{ color: "red" }}>{`(0 Tasks)`}</span></div>
        );
      }
    });
  }, [props.appointment]);

  // if (props.isEdit) {
  return (
    <>
      {isLoading ? (
        <>
          <CircularProgress size={20} />
        </>
      ) : (
        <div className="clientsingleSelect mt-8">
          <SingleSelect
            label="Select Shift"
            value={
              shiftDetails?.length === 1 &&
              shiftDetails[0]?.value === "No Shift"
                ? "No Shift"
                : selectedShift
            }
            className="field"
            name="selectedShift"
            onChange={(e) => {
              if (props?.appointment?.checkInDateTime) {
                setShowDialog(true);
                return;
              }
              if (
                !(
                  shiftDetails?.length === 1 &&
                  shiftDetails[0]?.value === "No Shift"
                )
              ) {
                onSelectShift(e);
              }
            }}
            options={shiftDetails}
            disabled={
              shiftDetails?.length === 1 &&
              shiftDetails[0]?.value === "No Shift"
            }
            trimShift={true}
          />
        </div>
      )}

      {showDialog && (
        <Dialog open={showDialog} onClose={() => setShowDialog(false)}>
          <DialogContent closeButton={false}>
            <DialogTitle className="mt-5 dark:text-white border-b pb-10">Shift Change Not Allowed</DialogTitle>
              <p className="font-medium text-[16px] dark:text-white mb-10 mt-5">This shift cannot be changed because work has started.</p>
              <div className="d-flex flex-justify-center">
              <Button style={{backgroundColor:"#16A34A", color:"white", maxWidth:"250px"}} variant="default" onClick={() => setShowDialog(false)} autoFocus>
              Close
              </Button>
              </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
  // } else {
  //   return (
  //     <>
  //       {selectedShift}
  //     </>
  //   );
  // }
};

const ClientCard = ({ clientsList, show, toggleShow, saveData, handelDeleteTime, getTimeZoneData, getStatusTag, getTaskListByComma, getTaskCount,
  getClientsSummaryData, setShow, checkInDateTime, checkOutDateTime, setCheckInDateTime, setCheckOutDateTime, durationString, setDurationString, itemsPerPage, auth }) => {

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const setIsModalOpen = auth?.setIsModalOpen;
  const setSelectedAppointment = auth?.setSelectedAppointment;

  const handleOpenDialog = (client) => {
    setSelectedClient(client);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedClient(null);
  };

  const [openNewDialog, setOpenNewDialog] = useState(false);
  const [selectedNewClient, setSelectedNewClient] = useState(null);

  const handleOpenNewDialog = (client) => {
    setSelectedNewClient(client);
    setOpenNewDialog(true);
  };

  const handleCloseNewDialog = () => {
    setOpenNewDialog(false);
    setSelectedNewClient(null);
  };

  return clientsList?.slice(0, itemsPerPage)?.map((appointment) => {
    const timezones = appointment?.calendarTimezone || 'America/New_York';
    const timezone = getTimeZoneData(timezones);

    const formattedStartDate = moment(appointment["appointmentDateTime"])
      .parseZone(timezones)
      .format("MMM DD YYYY");
    const formattedStartTime = moment(appointment["appointmentDateTime"])
      .parseZone(timezones)
      .format("h:mm a");

    const formattedEndDate = moment(appointment["appointmentDateTime"])
      .add(appointment["duration"], "minutes")
      .parseZone(timezones)
      .format("MMM DD YYYY");
    const formattedEndTime = moment(appointment["appointmentDateTime"])
      .add(appointment["duration"], "minutes")
      .parseZone(timezones)
      .format("h:mm a");

    return (
      <>
        <Box
          key={appointment.id}
          sx={{
            borderRadius: 2,
            border: "1px solid",
            borderColor: "divider",
            boxShadow: 1,
            mb: 2,
            p: 2,
          }}
          className="bg-white dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] text-[#020817] dark:text-white"
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            mb={2}
          >
            <Link
              to={`/peoples/createClient/${appointment?.clientId}`}
              className="text-blue-600 dark:text-blue-400 font-semibold text-lg"
            >
              {appointment["name"]}
            </Link>
            {getStatusTag(appointment)}
          </Box>

          <Grid container spacing={2} className="mb-8">
            <Grid item xs={6} className="flex flex-col">
              <Typography variant="body" className={styles.customHeader}>
                Start
              </Typography>
              <Typography
                variant="body"
                className="text-base font-medium text-[#020817] dark:text-white mt-1"
              >
                {formattedStartTime} {timezone?.abbr}
              </Typography>
              <Typography variant="body" className={styles.customHeader}>
                {formattedStartDate}
              </Typography>
            </Grid>
            <Grid item xs={6} className="flex flex-col">
              <Typography variant="body" className={styles.customHeader}>
                End
              </Typography>
              <Typography
                variant="body"
                className="text-base font-medium text-[#020817] dark:text-white mt-1"
              >
                {formattedEndTime} {timezone?.abbr}
              </Typography>
              <Typography variant="body" className={styles.customHeader}>
                {formattedEndDate}
              </Typography>
            </Grid>
          </Grid>

          <Box mb={2}>
            <Typography variant="body" className={styles.customHeader}>
              Shift
            </Typography>
            <ShiftStatus
              appointment={appointment}
              refreshData={getClientsSummaryData}
              isEdit={show[appointment.id]}
              setShow={setShow}
            />
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body" className={styles.customHeader2}>
              Employee:{" "}
              <Link
                to={`/peoples/createEmp/${appointment?.userId}`}
                className="text-blue-600 dark:text-blue-400"
              >
                {appointment.calendar}
              </Link>
            </Typography>
            <IconButton size="small" onClick={() => toggleShow(appointment.id)}>
              {show[appointment.id] ? (
                <ExpandLess className="text-black dark:text-white" />
              ) : (
                <ExpandMore className="text-black dark:text-white" />
              )}
            </IconButton>
          </Box>

          <Collapse in={show[appointment.id]} timeout="auto" unmountOnExit>
            <Box
              mt={2}
              pt={2}
              className="border-t border-gray-200 dark:border-gray-700"
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="body" className={styles.texts}>
                    Clock Times
                  </Typography>
                  {show[appointment?.id] ? (
                    <ClockInOut
                      show={show[appointment?.id]}
                      cellData={appointment}
                      checkInDateTime={checkInDateTime}
                      setCheckInDateTime={setCheckInDateTime}
                      checkOutDateTime={checkOutDateTime}
                      setCheckOutDateTime={setCheckOutDateTime}
                      setDurationString={setDurationString}
                      durationString={durationString}
                    />
                  ) : (
                    <>
                      <div>In: ----</div>
                      <div>Out: ----</div>
                    </>
                  )}
                </Grid>

                <Typography
                  variant="body"
                  className="pl-2 pt-3 font-medium text-sm text-[#020817] dark:text-white"
                >
                  Tasks
                </Typography>

                <Grid xs={12} className="flex mt-1 pl-2">
                  <Grid item xs={6} className="flex flex-col">
                    <Typography variant="body" className={styles.customHeader}>
                      Assigned:
                    </Typography>
                    <Typography
                      onClick={() => handleOpenDialog(appointment)}
                      className="mt-2 ml-2 text-base font-bold text-[#020817] dark:text-white cursor-pointer"
                    >
                      {getTaskCount(appointment, true)}
                    </Typography>
                  </Grid>

                  <Grid item xs={6} className="flex flex-col">
                    <Typography variant="body" className={styles.customHeader}>
                      Completed:
                    </Typography>
                    <Typography
                      onClick={() => handleOpenNewDialog(appointment)}
                      className="mt-2 ml-2 text-base font-bold text-[#020817] dark:text-white cursor-pointer"
                    >
                      {getTaskCount(appointment, false)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                mt={3}
                gap={1}
              >
                <div
                  onClick={() => {
                    setSelectedAppointment(appointment);
                    setIsModalOpen(true);
                  }}
                  className="text-blue-600 text-sm cursor-pointer"
                >
                  View Details
                </div>
                <div>
                  <Button
                    className="dark:text-white"
                    size="small"
                    variant="outlined"
                    onClick={() => handelDeleteTime(appointment)}
                  >
                    Cancel
                  </Button>
                  <Button
                    size="small"
                    variant="contained"
                    className="saveButton text-white dark:bg-[#078037] dark:text-white ml-15"
                    onClick={() => saveData(appointment)}
                  >
                    Save
                  </Button>
                </div>
              </Box>
            </Box>
          </Collapse>
        </Box>
        {openDialog && (
          <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            fullWidth
            maxWidth="sm"
          >
            <DialogContent className="mt-3 bg-white dark:bg-[#2c3440] dark:text-white">
              <Typography
                variant="body"
                className="mt-5 text-xl font-bold text-[#020817] dark:text-white"
              >
                Tasks Assigned
              </Typography>
              <Divider />
              {selectedClient && (
                <>
                  <Typography
                    variant="body"
                    className="text-base font-semibold mb-8 dark:text-white"
                  >
                    Regular Task
                  </Typography>
                  <Typography
                    variant="body"
                    className="text-sm text-gray-600 dark:text-white"
                  >
                    {getTaskListByComma(selectedClient)}
                  </Typography>

                  <Typography
                    variant="body"
                    className="mt-4 text-base font-semibold mb-8 dark:text-white"
                  >
                    Open Task
                  </Typography>
                  <Typography
                    variant="body"
                    className="text-sm text-gray-600 dark:text-white"
                  >
                    {getTaskListByComma(selectedClient, 1)}
                  </Typography>
                </>
              )}
              <div className="justify-center mb-5">
                <Button
                  variant="contained"
                  onClick={handleCloseDialog}
                  className="bg-green-700 text-white rounded-lg px-6 py-2"
                >
                  Close
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        )}
        {openNewDialog && (
          <Dialog
            open={openNewDialog}
            onClose={handleCloseNewDialog}
            fullWidth
            maxWidth="sm"
          >
            <DialogContent className="mt-12 bg-white dark:bg-[#2c3440] text-[#020817] dark:text-white">
              <Typography
                variant="body"
                className="mt-5 text-xl font-bold text-[#020817] dark:text-white"
              >
                Tasks Assigned
              </Typography>
              <Divider />
              {selectedNewClient && (
                <>
                  <Typography
                    variant="body"
                    className="text-base font-semibold mb-8 dark:text-white"
                  >
                    Completed Task
                  </Typography>
                  <Typography
                    variant="body"
                    className="text-sm text-gray-600 dark:text-white"
                  >
                    {getTaskListByComma(selectedClient, 2)}
                  </Typography>
                </>
              )}
              <div className="justify-center mb-5">
                <Button
                  variant="contained"
                  onClick={handleCloseNewDialog}
                  className="bg-green-700 text-white rounded-lg px-6 py-2"
                >
                  Close
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        )}
      </>
    );
  });
};

function ClientSummary() {
  const {
    sort,
    filterDate,
    clientsList,
    isLoading,
    setIsLoading,
    handleDateChange,
    renderRow,
    setShow,
    show,
    getClientsSummaryData,
    getTimeZoneData,
    getStatusTag,
    getTaskListByComma,
    getTaskCount,
    toggleShow,
    changeDate,
    itemsPerPage,
    setItemsPerPage,
    employee,
    clients,
    appointments,
    deleteDialog,
    setDeleteDialog,
    handelConfirmDeleteTime,
    setUpdateDialog,
    updateDialog,
    handleConfirmUpdateTime,
    checkInDateTime,
    setCheckInDateTime,
    checkOutDateTime,
    setCheckOutDateTime
  } = useClientSummary(true);

  const [refreshing, setRefreshing] = useState(false);
  const auth = useContext(AuthContext);
  const isMobile = useMediaQuery('(max-width:767px)');
  const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
  const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const [settingsData, setSettingsData] = useState(null);
  // const [checkInDateTime, setCheckInDateTime] = useState(null);
  const [cancelAppt, setCancelAppt] = useState(false);
  // const [checkOutDateTime, setCheckOutDateTime] = useState(null);
  const [durationString, setDurationString] = useState("—");
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const isModalOpen = auth.isModalOpen;
  const setIsModalOpen = auth.setIsModalOpen;
  const selectedAppointment = auth.selectedAppointment;
  const setSelectedAppointment = auth.setSelectedAppointment;
  const editAppointmentData = auth?.editAppointmentData?.selectedAppointment;
  const updateAppointmentData = auth.updateAppointmentData?.matchingAppointments;
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const { toast } = useToast();

   const handelDeleteTime = async (cellData) => {
    setDeleteDialog({open: true, cellData: cellData})
  };

  const saveData = async (cellData) => {
    setUpdateDialog({open: true, cellData: cellData})
  };

  const handleItemsPerPageChange = async (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    const userId = auth?.userProfile?.id;
    addPreferenceUser(userId, newItemsPerPage);
    await getClientsSummaryData(false, newItemsPerPage);
  };

  useEffect(() => {
    if (auth?.userProfile?.preference) {
      setItemsPerPage(auth.userProfile.preference);
    }
    // getSettings('appointment_settings', (res) => {
    //   const data = res?.data?.find(item => item.companyId === companyId && !item.deleted);
    //   if (data?.schedulingSystem === "acuity") {
    //     setSettingsData(data);
    //   } else {
    //     setSettingsData(null);
    //   }
    // })
  }, []);

  const handelCancelCloseDialog = () => {
    setCancelAppt(false);
  }

  const handelSingleOrSeriesApptCancelDialog = async (ids, mode) => {
    // const ids = editAppointmentData?.id;
    const data = {
      name: `${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName}`,
      id: auth?.userProfile?.id
    }
    setCancelAppt(false);
    const response = await DeleteAppointment(ids, data, mode);
    if (response.success) {
      setIsDeleteDialogOpen(true);
    } else {
      console.error("Failed to delete appointment:", response.error);
    }
  }

  const handelSuccelDeleteCloseDialog = async () => {
    setIsLoading(true);
    setShow(false);
    auth.setEditAppointmentData({});
    auth.setUpdateAppointmentData({});
    setIsDeleteDialogOpen(false);
    setIsModalOpen(false);
    setCancelAppt(false);
    await delay(3500);
    await getClientsSummaryData();
    toast?.({
      title: "Success",
      description: "Appointment Deleted Successfully",
      variant: "default",
    });
    setIsLoading(false);
  };

  return (
    <>
      <Grid container alignItems="center" spacing={2} className="mb-10">
        <Grid
          item
          xs={12}
          sm={12}
          lg={6}
          className="d-flex flex-center flex-space-between"
        >
          <Typography
            variant="h6"
            className="text-gray-900 dark:text-white"
            style={{ fontSize: "20px", lineHeight: "28px", fontWeight: "600" }}
          >
            <AssignmentOutlinedIcon className="color-lightGreen mr-10 svg-icon" />
            Daily Summary
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} lg={6} data-tour="date-navigation">
          <div
            className={
              isMobile || isLandscape
                ? "d-flex flex-center flex-space-between groupsearch"
                : "d-flex flex-center groupsearch float-right"
            }
          >
            {/* {settingsData !== null && (
              <div>
                <IconButton onClick={handleRefresh} disabled={refreshing}>
                  <FontAwesomeIcon icon={faSyncAlt} className={styles.Action} />
                </IconButton>
              </div>
            )} */}
            <div className="d-flex flex-center">
              <IconButton onClick={() => changeDate(-1)} className="p-4">
                <ChevronLeft
                  fontSize="large"
                  className="text-black dark:text-white"
                />
              </IconButton>
              <TextField
                name="date"
                value={filterDate}
                fullWidth={true}
                size="small"
                variant="outlined"
                className={`field w-50`}
                type={"date"}
                InputProps={{
                  classes: {
                    root: "bg-white dark:bg-[#1A1F2C] text-black dark:text-white",
                    input: "p-10",
                  },
                }}
                inputProps={{
                  className: "p-10",
                  min: moment().add(-30, "days").format("YYYY-MM-DD"),
                  max: moment().add(15, "days").format("YYYY-MM-DD"),
                }}
                onChange={handleDateChange}
              />
              <IconButton onClick={() => changeDate(1)} className="p-4">
                <ChevronRight
                  fontSize="large"
                  className="text-black dark:text-white"
                />
              </IconButton>
            </div>
          </div>
        </Grid>
      </Grid>
      <div
        className={`dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] sectionBox nospacing position-relative clientWrap ${styles.summaryTableWrap}`}
        style={{ padding: isMobile ? "10px 8px" : "0px", borderRadius: "8px" }}
      >
        {!isMobile && !isLandscape && (
          <Box>
            {isLoading ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "12px",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
                className="text-foreground"
              >
                Loading...
              </div>
            ) : clientsList?.length === 0 ? (
              <div className="pv-30 ph-15 text-center text-md dark:text-white fw-bold">
                No Records Found
              </div>
            ) : (
              <>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow className="bg-[#f8fafc] dark:bg-[#1A1F2C]">
                        <TableCell className="text-[#020817] dark:text-[#94A3B8] font-medium">
                          Client
                        </TableCell>
                        <TableCell className="text-[#020817] dark:text-[#94A3B8] font-medium">
                          Status
                        </TableCell>
                        <TableCell className="text-[#020817] dark:text-[#94A3B8] font-medium">
                          Shift
                        </TableCell>
                        <TableCell className="text-[#020817] dark:text-[#94A3B8] font-medium">
                          Start
                        </TableCell>
                        <TableCell className="text-[#020817] dark:text-[#94A3B8] font-medium">
                          End
                        </TableCell>
                        <TableCell
                          align="right"
                          className="text-[#020817] dark:text-[#94A3B8] font-medium"
                        >
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>{renderRow()}</TableBody>
                  </Table>
                  <CustomPagination
                    itemsPerPage={itemsPerPage}
                    onItemsPerPageChange={handleItemsPerPageChange}
                  />
                </TableContainer>
              </>
            )}
          </Box>
        )}

        {(isMobile || isLandscape) && (
          <div>
            {refreshing === true ? (
              <div className="pv-10 ph-15 text-center dark:text-white fw-bold">Loading...</div>
            ) : clientsList?.length === 0 ? (
              <div className="pv-10 ph-15 text-center dark:text-white fw-bold">
                No Records Found
              </div>
            ) : (
              <>
                <ClientCard
                  clientsList={clientsList}
                  show={show}
                  toggleShow={toggleShow}
                  saveData={saveData}
                  handelDeleteTime={handelDeleteTime}
                  getTimeZoneData={getTimeZoneData}
                  getStatusTag={getStatusTag}
                  getTaskListByComma={getTaskListByComma}
                  getTaskCount={getTaskCount}
                  getClientsSummaryData={getClientsSummaryData}
                  setShow={setShow}
                  checkInDateTime={checkInDateTime}
                  checkOutDateTime={checkOutDateTime}
                  setCheckInDateTime={setCheckInDateTime}
                  setCheckOutDateTime={setCheckOutDateTime}
                  durationString={durationString}
                  setDurationString={setDurationString}
                  itemsPerPage={itemsPerPage}
                  auth={auth}
                />
                <CustomPagination
                  itemsPerPage={itemsPerPage}
                  onItemsPerPageChange={handleItemsPerPageChange}
                />
              </>
            )}
          </div>
        )}
      </div>

      {selectedAppointment && (
        <ScheduleModal
          isModalOpen={isModalOpen}
          selectedAppointment={selectedAppointment}
          isMobile={isMobile}
          isLandscape={isLandscape}
          clientDetails={clients}
          employeeDetails={employee}
          appoinments={appointments}
          auth={auth}
          setIsModalOpen={setIsModalOpen}
          setCancelAppt={setCancelAppt}
          settingsData={settingsData}
          alerts={"todayAlerts"}
        />
      )}

      {cancelAppt && (
        <DeleteApptDialog
          open={cancelAppt}
          client={clients}
          onConfirm={handelSingleOrSeriesApptCancelDialog}
          auth={editAppointmentData}
          onClose={handelCancelCloseDialog}
          appointments={updateAppointmentData}
        />
      )}

      {isDeleteDialogOpen && (
        <CommonSuccessDialog
          open={isDeleteDialogOpen}
          onClose={handelSuccelDeleteCloseDialog}
          title="Appointment Deleted Successfully"
          message="Your appointment has been successfully deleted. Thank you for using our scheduling system."
        />
      )}

      {deleteDialog?.open && (
        <CommonConfirmationDialog 
         open={deleteDialog?.open}
         onConfirm={handelConfirmDeleteTime}
         onClose={()=> setDeleteDialog({open: false, cellData: null})}
         title={"Confirm Deletion"}
         message={"Are you sure you want to cancel? This will permanently delete the check-in and check-out data."}
        />
      )}

      {updateDialog?.open && (
        <CommonConfirmationDialog 
         open={updateDialog?.open}
         onConfirm={handleConfirmUpdateTime}
         onClose={()=> setUpdateDialog({open: false, cellData: null})}
         title={"Confirm Update"}
         message={"Are you sure you want to update? This action will update the check-in and check-out data."}
        />
      )}
    </>
  );
}

const ScheduleModal = (props) => {
  const { isModalOpen } = props;
  const [isModalO, setIsModalO] = useState(false);


  useEffect(() => {
    if (isModalOpen) {
      setIsModalO(isModalOpen);
    } else {
      setTimeout(() => {
        setIsModalO(isModalOpen);
      }, 250);
    }

  }, [isModalOpen]);

  const handleOverlayClick = (e) => {
    if (e.target?.classList?.contains('modal-overlay')) {
      props?.setIsModalOpen(false);
      props?.auth?.setEditAppointmentData({});
      props?.auth?.setUpdateAppointmentData({});
    }
  };

  return isModalO ? (
    <div className={`modal-overlay active`} onClick={handleOverlayClick} >
      <div className={`modal-content dark:bg-[#1A1F2C] ${isModalOpen ? 'slideUpModal' : 'slideDownModal'}`}>
        {" "}
        <AppointmentModal {...props} />{" "}
      </div>
    </div>
  ) : null;
};

export default ClientSummary;
